import { fmt, fmtFecha } from '../services/api'

// Componente de boleta imprimible — formato térmico 80mm estilo BSale
export default function Boleta({ venta, usuario }) {
  if (!venta) return null
  const { documento, items, pago, vuelto } = venta

  // 'nota_venta' es el Ticket detalle de venta: comprobante interno, sin SII.
  const esTicket = documento?.tipo === 'nota_venta'
  const titulo = esTicket ? 'COMPROBANTE DE VENTA' : 'BOLETA ELECTRÓNICA'

  // Pie legal: debe decir UNA sola cosa y que sea cierta.
  const pieLegal = esTicket
    ? 'Documento interno — no válido como boleta'
    : (documento?.sii_estado === 'emitido'
        ? 'Documento tributario electrónico emitido ante el S.I.I.'
        : 'Boleta interna — sin validez tributaria oficial')

  return (
    <div id="boleta-imprimir" style={{
      width: '80mm', margin: '0 auto', padding: '10px',
      fontFamily: "'Courier New', monospace", fontSize: '11px',
      color: '#000', background: '#fff', lineHeight: 1.4
    }}>
      {/* Header */}
      <div style={{textAlign:'center', marginBottom:8}}>
        <div style={{border:'1px solid #000', padding:'6px', marginBottom:6}}>
          <div style={{fontWeight:700, fontSize:11}}>RUT {usuario?.empresa_rut || '—'}</div>
          <div style={{fontWeight:700, fontSize:12, margin:'2px 0'}}>{titulo}</div>
          <div style={{fontWeight:700, fontSize:11}}>N° {documento.folio || documento.id?.slice(-6).toUpperCase()}</div>
        </div>
        {/* La línea del S.I.I. solo corresponde en un documento tributario */}
        {!esTicket && (
          <div style={{fontWeight:600}}>S.I.I. - {usuario?.empresa_ciudad?.toUpperCase() || ''}</div>
        )}
      </div>

      {/* Datos empresa */}
      <div style={{textAlign:'center', marginBottom:8}}>
        <div style={{fontWeight:700, fontSize:12}}>{usuario?.empresa_razon_social || usuario?.empresa_nombre}</div>
        {usuario?.empresa_giro && <div>{usuario.empresa_giro}</div>}
      </div>

      {/* Detalle empresa y venta */}
      <div style={{marginBottom:8}}>
        {usuario?.empresa_direccion && <div>Dirección: {usuario.empresa_direccion}</div>}
        {usuario?.empresa_comuna && <div>Comuna: {usuario.empresa_comuna}</div>}
        {usuario?.empresa_ciudad && <div>Ciudad: {usuario.empresa_ciudad}</div>}
        {usuario?.empresa_telefono && <div>Fono: {usuario.empresa_telefono}</div>}
        <div>Vendedor: {usuario?.nombre}</div>
        <div>Fecha: {fmtFecha(documento.creado_en || new Date())}</div>
        <div>Forma de Pago: {pago?.nombre?.toUpperCase() || '—'}</div>
      </div>

      {/* Tabla items */}
      <div style={{borderTop:'1px solid #000', borderBottom:'1px solid #000', padding:'4px 0', marginBottom:8}}>
        <div style={{display:'flex', fontWeight:700, marginBottom:4}}>
          <div style={{width:'15%'}}>CANT.</div>
          <div style={{width:'40%'}}>ÍTEM</div>
          <div style={{width:'22%', textAlign:'right'}}>VALOR U.</div>
          <div style={{width:'23%', textAlign:'right'}}>SUBTOTAL</div>
        </div>
        {items.map((item, i) => (
          <div key={i} style={{display:'flex', marginBottom:2}}>
            <div style={{width:'15%'}}>{item.cantidad}</div>
            <div style={{width:'40%', wordBreak:'break-word'}}>{item.descripcion}</div>
            <div style={{width:'22%', textAlign:'right'}}>{fmt(item.precio_unitario)}</div>
            <div style={{width:'23%', textAlign:'right'}}>{fmt(item.cantidad * item.precio_unitario)}</div>
          </div>
        ))}
      </div>

      {/* Totales */}
      <div style={{border:'1px solid #000', padding:'6px', marginBottom:10}}>
        <div style={{display:'flex', justifyContent:'space-between', fontWeight:600}}>
          <span>NETO:</span><span>{fmt(documento.neto)}</span>
        </div>
        <div style={{display:'flex', justifyContent:'space-between', fontWeight:600}}>
          <span>IVA:</span><span>{fmt(documento.iva)}</span>
        </div>
        <div style={{display:'flex', justifyContent:'space-between', fontWeight:600}}>
          <span>Total Exento:</span><span>{fmt(documento.exento || 0)}</span>
        </div>
        {vuelto > 0 && (
          <div style={{display:'flex', justifyContent:'space-between', fontWeight:600}}>
            <span>Vuelto:</span><span>{fmt(vuelto)}</span>
          </div>
        )}
        <div style={{display:'flex', justifyContent:'space-between', fontWeight:800, fontSize:13, borderTop:'1px solid #000', marginTop:4, paddingTop:4}}>
          <span>TOTAL:</span><span>{fmt(documento.total)}</span>
        </div>
      </div>

      {/* Footer */}
      <div style={{textAlign:'center', fontSize:10, color:'#333'}}>
        <div style={{marginBottom:4}}>{pieLegal}</div>
        <div>Generado por RedCaja</div>
      </div>
    </div>
  )
}
